import React, { useState, useEffect } from 'react';
import { api } from '../../services/api';
import './Salary.css';

export default function Salary({ employee }) {
  const [salary, setSalary] = useState(null);
  const [loading, setLoading] = useState(true);

  const now = new Date();
  const month = now.getMonth() + 1;
  const year = now.getFullYear();

  useEffect(() => {
    loadSalary();
  }, []);

  const loadSalary = async () => {
    try {
      setLoading(true);
      const data = await api.getMySalary(month, year);
      setSalary(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const POLICY = [
    { category: 'Minor Late', threshold: '10–30 minutes', deduction: 'Casual leave' },
    { category: 'Major Late', threshold: '30–60 minutes', deduction: 'Casual leave' },
    { category: 'Every 3 Lates', threshold: 'In one month', deduction: '½ day salary/leave' },
    { category: 'Every 6 Lates', threshold: 'In one month', deduction: '1 day salary/leave' },
    { category: 'Unauthorized Absent', threshold: 'No clock-in', deduction: '1 day salary' },
    { category: 'Grace Period', threshold: '—', deduction: '20 minutes' },
  ];

  return (
    <div className="salary-page">

      <div className="sal-section-label">
        {now.toLocaleString('default', { month: 'long' })} {year} — Salary Impact
      </div>

      {loading ? (
        <div style={{textAlign:'center', padding:'30px', color:'var(--muted)'}}>Calculating...</div>
      ) : salary?.error ? (
        <div style={{textAlign:'center', padding:'20px', color:'var(--red)', fontSize:'13px'}}>{salary.error}</div>
      ) : (
        <>
          {/* Deduction percentage banner */}
          <div className="net-banner">
            <div className="net-label">Total Deduction This Month</div>
            <div className="net-amount">{salary?.deduction_percent || '0.00'}%</div>
            <div className="net-sub">of your monthly salary</div>
          </div>

          <div className="salary-stats">
            <div className="sal-stat amber">
              <div className="sal-stat-label">Days Absent</div>
              <div className="sal-stat-val">{salary?.absent_days || 0}</div>
              <div className="sal-stat-sub">unauthorized</div>
            </div>
            <div className="sal-stat red">
              <div className="sal-stat-label">Late Count</div>
              <div className="sal-stat-val">{salary?.late_count || 0}</div>
              <div className="sal-stat-sub">this month</div>
            </div>
          </div>

          <div className="sal-section-label">Breakdown</div>
          <div className="sal-card">
            <div className="sal-row base">
              <span className="sal-label">Absent Deduction</span>
              <span className="sal-val deduct">
                {salary?.absent_days > 0 ? `${salary.absent_days} day(s)` : 'None'}
              </span>
            </div>
            <div className="sal-row base">
              <span className="sal-label">Late Deduction</span>
              <span className="sal-val deduct">
                {salary?.late_count > 0 ? `${salary.late_count} late(s)` : 'None'}
              </span>
            </div>
            <div className="sal-row base">
              <span className="sal-label">Casual Leaves Consumed</span>
              <span className="sal-val deduct">
                {salary?.casual_leaves_consumed > 0 ? `${salary.casual_leaves_consumed} day(s)` : 'None'}
              </span>
            </div>
            <div className="sal-row base">
              <span className="sal-label">Approved Leaves</span>
              <span className="sal-val" style={{color:'var(--green)'}}>
                {salary?.approved_leaves || 0} day(s)
              </span>
            </div>
            <div className="sal-row net">
              <span>Total Deduction</span>
              <span className="sal-val deduct">{salary?.deduction_percent || '0.00'}% of salary</span>
            </div>
          </div>

          <div className="sal-section-label" style={{marginTop: 16}}>Policy Reference</div>
          <div className="sal-card">
            <div className="policy-header">
              <span>Rule</span>
              <span>When</span>
              <span>Penalty</span>
            </div>
            {POLICY.map((p, i) => (
              <div key={i} className="policy-row">
                <span className="policy-cat">{p.category}</span>
                <span className="policy-thresh">{p.threshold}</span>
                <span className="policy-ded">{p.deduction}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}